import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDashboardCounts, fetchAdminDashboardCounts } from '../../api/dashboardApi';

export const getDashboardCounts = createAsyncThunk('dashboard/getDashboardCounts', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchDashboardCounts(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getAdminDashboardCounts = createAsyncThunk('dashboard/getAdminDashboardCounts', async (_, { rejectWithValue }) => {
  try {
    const response = await fetchAdminDashboardCounts();
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    dashboardCounts: [],
    adminDashboardCounts: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardCounts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getDashboardCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.dashboardCounts = action.payload;
      })
      .addCase(getDashboardCounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getAdminDashboardCounts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getAdminDashboardCounts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adminDashboardCounts = action.payload;
      })
      .addCase(getAdminDashboardCounts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default dashboardSlice.reducer;
